import {UI} from "../../../stem-core/src/ui/UIBase";

import {NOOP_FUNCTION} from "../../../stem-core/src/base/Utils";
import {CustomAmountButton} from "./CustomAmountButton";
import {DonateActiveButtonList} from "./DonateActiveButtonList";
import {Device} from "../../../stem-core/src/base/Device";


export class DonateAmountButtonList extends DonateActiveButtonList {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            onCustomInputError: NOOP_FUNCTION,
            onValidCustomInput: NOOP_FUNCTION,
            CustomAmountButtonClass: CustomAmountButton,
            customAmountButtonOptions: {
                currency: null,
                defaultCustomAmount: null,
                minAmount: null,
                maxAmount: null,
            },
        };
    }

    hasCustomAmountButton() {
        if (!this.options.customAmountButtonOptions) {
            return false;
        }

        // check if all the required custom amount button options are specified
        const {currency, minAmount, maxAmount} = this.options.customAmountButtonOptions;

        return currency && minAmount && maxAmount;
    }

    getTotalButtonsCount() {
        return super.getTotalButtonsCount() + (this.hasCustomAmountButton() ? 1 : 0);
    }

    getButtonElements() {
        if (!this.hasCustomAmountButton()) {
            return super.getButtonElements();
        }

        const totalButtonsCount = this.getTotalButtonsCount();
        const {onCustomInputError, onValidCustomInput, CustomAmountButtonClass} = this.options;
        const {currency, minAmount, maxAmount, defaultCustomAmount} = this.options.customAmountButtonOptions;

        return [
            ...super.getButtonElements(),
            <CustomAmountButtonClass
                ref="customAmountButton"
                testId="customAmountButton"
                className={this.styleSheet.listItem}
                currency={currency} minAmount={minAmount} maxAmount={maxAmount}
                onInputError={onCustomInputError} onValidInput={onValidCustomInput}
                defaultAmount={currency.amountToMainUnits(defaultCustomAmount)}
                active={this.activeButtonIndex === totalButtonsCount - 1}
                onClick={() => {
                    if (Device.isMobileDevice()) {
                        this.customAmountButton.node.scrollIntoView({behavior: "smooth"});
                    }
                    this.updateActive(totalButtonsCount - 1);
                    this.handleCustomAmountChange(this.customAmountButton.getInputValue());
                }}
                onInputChange={(value) => this.handleCustomAmountChange(value)}
                onInputBlur={() => this.handleCustomAmountInputBlur()}/>
        ]
    }

    handleCustomAmountInputBlur() {
        const customAmountInputValue = this.customAmountButton.getInputValue();
        if (customAmountInputValue != null && customAmountInputValue.length === 0) {
            this.activeButtonIndex = null;
            this.redraw();
        }
    }

    handleCustomAmountChange(value) {
        const {onSelect, customAmountButtonOptions} = this.options;
        onSelect({amount: customAmountButtonOptions.currency.mainUnitsToAmount(value), isCustomAmount: true});
    }

    handleButtonClick(buttonIndex) {
        const {onSelect, items} = this.options;
        this.updateActive(buttonIndex);
        onSelect({amount: items[buttonIndex].value, isCustomAmount: false});
    }
}
